import { useQuery } from '@tanstack/react-query'
import { PlusIcon } from 'lucide-react'
import { Button, ButtonProps } from '../../../components'
import { useCogfy } from '../../../hooks'

export function AddGoogleCalendarButton (props: ButtonProps) {
  const cogfy = useCogfy()

  const data = {
    provider: 'googleCalendar' as const
  }
  const getGoogleCalendarAuthUrl = useQuery({
    queryKey: ['getGoogleAuthUrl', data],
    queryFn: ({ signal }) => cogfy.getGoogleAuthUrl(data, { signal })
  })

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getGoogleCalendarAuthUrl.isLoading}
      to={getGoogleCalendarAuthUrl.data?.authUrl}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
